import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from '@/providers/ThemeProvider';

window.onerror = function(message, source, lineno, colno, error) {
  console.error("Global error:", message, error);
  document.body.innerHTML = `<div style="color: red; padding: 20px;"><h1>Erro na aplicação</h1><pre>${message}</pre></div>`;
};

console.log("Index.tsx is loading...");

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);